export const LOGIN_SIGNIN = 'Sign in';
export const LOGOUT = 'Log out';
export const LOGIN_RETRY = 'Retry sign in';
export const COMING_SOON = 'Coming soon';
export const SELECT_ORGANISATION = 'Select organisation';
export const LOGIN_COOKIES_DISABLED = 'Please enable cookies in your browser to proceed with sign in';
export const ERROR_NOTIFICATION_MESSAGE = {
    href: 'https://www.seequent.com/help-support/',
    preLinkedText: 'An error occurred or you do not have access to this server. Please contact the service admin, or if you still have issues visit ',
    linkedText: 'Seequent support.',
};
export const LOGIN_SIDEBAR_DOWNLOADS = 'Downloads';
export const LOGIN_SIDEBAR_DOWNLOADS_BLURB = 'Stay up to date with the latest version of Seequent software.';
export const LOGIN_SIDEBAR_DOWNLOADS_LINK = {
    href: 'https://my.seequent.com/products',
    preLinkedText: 'Access our ',
    linkedText: 'software downloads here',
};
export const LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_TITLE = 'Training and support';
export const LOGIN_SIDEBAR_TRAINING_AND_SUPPORT = 'We have a wide range of help and support documentation available online.';
export const LOGIN_SIDEBAR_TRAINING_AND_SUPPORT_LINK = {
    preLinkedText: 'Learn more about',
    href: 'https://www.seequent.com/help-support/seequent-central/',
    linkedText: 'online training here',
};
export const LOGOUT_REDIRECT_ERROR = 'Error redirecting back to Login';
export const RIGHTS_RESERVED = '© Seequent, The Bentley Subsurface Company. All rights reserved';
export const CREATE_ID_LABEL = 'Create a Seequent ID';
export const CREATE_LOGIN = "Don't have an account?";
export const TERMS_OF_USE_LINK = {
    href: `https://www.seequent.com/legal-privacy/online-services-user-terms/`,
    linkedText: 'User terms',
};
export const PRIVACY_POLICY_LINK = {
    href: `https://www.seequent.com/legal-privacy/privacy-policy/`,
    linkedText: 'Privacy policy',
};
export const RETRIEVE_BENTLEY_ACCESS_TOKEN_ERROR = 'Error retrieving Bentley access token, please login again';
export const SESSION_HAS_EXPIRED_TITLE = 'Your session has expired';
export const SESSION_HAS_EXPIRED_TEXT = 'Please sign in again to continue using the application.';
export const SESSION_HAS_EXPIRED_RETRY_TEXT = 'If the popup did not open, please click the button below to try again.';
export const INCORRECT_IDENTITY_PROVIDER_SEEQUENT = 'Want to use your Seequent instances? Sign in with a Seequent ID.';
export const INCORRECT_IDENTITY_PROVIDER_BENTLEY = 'Want to use your Bentley instances? Sign in with a Bentley Account.';
//# sourceMappingURL=strings.js.map